import Http from "./http";

export const updateEmailTemplateAPI = (data) => {
  return Http.post("admin/email-templates/updateTemplate",data);
};
